import { render, staticRenderFns } from "./secondary.vue?vue&type=template&id=222200e9&"
import script from "./secondary.vue?vue&type=script&lang=js&"
export * from "./secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports